import { Header } from "modules/Header";
import { useMainPages } from "modules/Header/data";
import { useQuery } from "react-query";
import { Get } from "utils/request";
import logo from "assets/images/rt/icon_transparent.png";
import { STORAGE_URL } from "variables";
import { useHistory } from "react-router";
import { Box, Typography } from "@mui/material";
import bg_image from "assets/images/bg-categories.jpg";
import { Carousel } from "react-responsive-carousel";
import { useEffect, useState } from "react";
import { removeHTML } from "utils/filters";

const CategoriesCoursePage = () => {
  const pages = useMainPages();
  const history = useHistory();
  const [banners, SetBanners] = useState([]);

  const { isLoading, data } = useQuery(
    "categories-courses",
    async () => await Get("courses-main/courses_wall")
  );
  const { courses } = data || {};

  const fetchBanners = async () => {
    const { data } = await Get("styles/pages/course_wall");
    console.log(data);
    return data;
  };

  useEffect(() => {
    fetchBanners().then((data) => SetBanners(data));
  }, []);

  return (
    <div
      style={{
        backgroundColor: "black",
        overflowX: "hidden",
        position: "relative",
        overflowY: "auto",
        minHeight: "100vh",
      }}
    >
      <Header pages={pages} />

      <div
        style={{
          width: "100%",
          position: "relative",
          zIndex: 20,
        }}
      >
        {banners?.length > 0 && (
          <Carousel
            autoPlay={true}
            infiniteLoop={true}
            renderIndicator={false}
            centerMode={false}
            showThumbs={false}
            transitionTime={500}
            interval={5000}
            showStatus={false}
          >
            {banners &&
              banners.map((banner, index) => (
                <a
                  key={banner.id}
                  href={banner.link}
                  target="_blank"
                  style={{
                    zIndex: 20,
                    position: "relative",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      aspectRatio: "3 / 1",
                      backgroundSize: "contain",
                      backgroundImage: `url(${STORAGE_URL + banner.image})`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                </a>
              ))}
          </Carousel>
        )}
      </div>

      <img
        src={bg_image}
        style={{
          width: "100vw",
          objectFit: "contain",
          position: "absolute",
          top: "0",
          left: "0",
          opacity: "0.3",
          zIndex: 1,
          webkitMaskImage:
            "linear-gradient(to top, transparent 5%, white 100%)",
          maskImage: "linear-gradient(to top, transparent 5%, white 100%)",
        }}
      />

      {isLoading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "2rem",
            height: "80vh",
            fontWeight: "bold",
            zIndex: 20,
            position: "relative",
          }}
        >
          <img
            src={logo}
            width="100"
            height="100"
            className="infiniteRotateAnim"
          />
          <span>Carregando...</span>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "4rem",
            padding: "1rem",
            marginTop: "6rem",
            zIndex: 20,
            position: "relative",
          }}
        >
          {courses?.map((course) => (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "rgba(255, 255, 255, 0.2)",

                width: "100%",
                maxWidth: "60rem",
                objectFit: "contain",
                borderRadius: "1rem",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",

                "&:hover": {
                  filter: "brightness(1.1)",
                  transform: "scale(1.05)",
                },
              }}
              onClick={() => history.push(`/courses/adquire/${course?.id}`)}
            >
              <Box
                component="img"
                src={
                  course?.thumbnail_image
                    ? STORAGE_URL + course?.thumbnail_image
                    : STORAGE_URL + course?.image
                }
                style={{
                  width: "100%",
                  aspectRatio: "22/9",
                  objectFit: "cover",
                }}
              />

              {console.log(course?.showNameSalesPage)}

              <div
                style={{
                  display: course?.showNameSalesPage ? "block" : "none",
                  padding: "0.4rem 0.8rem",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    color: "white",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {removeHTML(course?.name)}
                </Typography>
              </div>
            </Box>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoriesCoursePage;
